define('ads/index',['jsx!components/react-ad/helper', 'ads/ad', 'lib', 'underscore', 'event-manager'], function(AdComponent, Ad, lib, _, eventManager) {
    'use strict';

    var placementPrefix = '';

    function initAd(ad) {
        new Ad(ad);
    }

    var Ads = {
        onReady: function(fn) {
            if (!window.apntag) {
                window.apntag = {};
                window.apntag.anq = [];
            }

            apntag.anq.push(fn);
        },
        init: function() {
            var tags = apntag.requests.tags;
            if (_.isEmpty(tags)) {
                return setTimeout(this.init, 100);
            }

            var $secSkyscraperContainer = $('#secondary-skyscraper-container');
            if ($secSkyscraperContainer.length > 0) {
                var height = $(document).height() - $secSkyscraperContainer.offset().top;
                $('#skyscraper-sticky-container-right-2').css({
                    height: height,
                });
            }

            var rendered = _.filter(tags, { displayed: true });
            var deferred = _.filter(tags, { displayed: false });

            if (rendered.length) {
                _.each(rendered, function(ad) {
                    if (ad.adResponse && _.isArray(ad.adResponse.ads) &&
                        ad.adResponse.ads[0].ad_type !== 'banner' &&
                        ad.adResponse.ads[0].rtb.native) {
                            var nativeAd = ad.adResponse.ads[0].rtb;
                            AdComponent(document.getElementById(ad.targetId + '-container'), {
                                native: nativeAd.native
                            });
                    } else {
                        initAd(ad);
                    }
                });
            }

            if (deferred.length) {
                _.each(deferred, function(ad) {
                    if (ad.empty) {
                        initAd(ad);
                    } else {
                        ad.on('adNoBid', function() {
                            ad.empty = true;
                            initAd(ad);
                        });
                    }
                });
            }
        },
        loadTags: function() {
            this.onReady(function() {
                apntag.loadTags();
            });
            return this;
        },
        // Show ad if AN is ready for it.
        showAd: function(ad) {
            this.onReady(function() {
                var id = ad.getAttribute('id');

                apntag.onEvent('adLoaded', id, function() {
                    ad.classList.add('ad-loaded');
                });
            });
            return this;
        },
        // Function for defining a single ad and showing it right away
        renderAd: function(ads) {
            function createAd(data) {
                var targetId = 'ad-' + placementPrefix + data.adFormat;
                apntag.defineTag({
                    invCode: data.invCode,
                    keywords: {
                        'no-sno-adformat': data.adFormat
                    },
                    sizes: data.sizes,
                    alwaysUseXDomainIframe: data.safeFrame || false,
                    targetId: targetId
                });
            }

            this.onReady(function() {
                if (_.isArray(ads)) {
                    _.each(ads, createAd);
                } else {
                    createAd(ads);
                }

                apntag.loadTags();
            });
        }
    };

    function collapseAd(tagname) {
        var $container = $('#'+tagname);
        if (!$container.length) {
            return;
        }

        lib.raf(function() {
            $container.hide();

            if (tagname === 'ad-netboard_1' && lib.getArticleId()) {
                $('.rightColumn.article-siteboard').css({
                    'margin-top': 15
                });
            }
        });
    }

    _.bindAll(Ads, _.methods(Ads));

    eventManager.once('domready', function loadAds() {
        if (window.apntag) {
            var ads = _.toArray(document.querySelectorAll('.appnexus')).filter(function(ad) {
                return ad.className.indexOf('ad-defer') === -1;
            });

            if (ads.length) {
                _.each(ads, Ads.showAd);
            }
        }
    });

    eventManager.once('domready', function() {
        Ads.onReady(function() {
            Ads.init();

            apntag.onEvent('adLoaded', function(event) {
                var tags = apntag.requests.tags;
                var ad = tags[event.targetId];

                if (event.adType === 'native') {
                    var native = event.native;
                    AdComponent(document.getElementById(ad.targetId + '-container'), {
                        native: native
                    });
                } else {
                    initAd(ad);
                }
            });
        });
    });

    function collapseNative(element) {
        var el;
        switch(element) {
            case 'native-premium-embed_1':
                el = document.getElementById('adPlaceholderFront');
                AdComponent(el, {
                    name: placementPrefix + (lib.isMobile() ? 'board_3' : 'netboard_1'),
                });
                break;
            case 'native-premium-embed_2':
                el = document.getElementById('adPlaceholderFrontTwo');
                AdComponent(el, {
                    name: placementPrefix + 'netboard_2',
                });
                break;
            case 'native-wide-embed_1':
                if (lib.isMobile()) {
                    el = document.getElementById('adPlaceholderFrontThree');
                    AdComponent(el, {
                        name: placementPrefix + 'board_1',
                    });
                }
                break;
            case 'native-premium-article-embed_1':
                el = document.getElementById('adPlaceholderArticle');
                AdComponent(el, {
                    name: placementPrefix + 'netboard_2',
                });
                break;
        }

        if (el) el.classList.add('loaded');
    }

    function collapseBlink(element) {
        var el;
        switch(element) {
            case 'finn_blink_front':
                el = document.getElementById('blinkPlaceholderFront');
                AdComponent(el, {
                    name: placementPrefix + (lib.isMobile() ? 'board_4' : 'netboard_3'),
                });
                break;
            case 'finn_blink_article':
                el = document.getElementById('blinkPlaceholderArticle');
                AdComponent(el, {
                    name: placementPrefix + (lib.isMobile() ? 'board_2' : 'netboard_1'),
                });
                break;
        }
    }

    eventManager.on('collapse-native', function(e, element) {
        collapseNative(element);
    });

    eventManager.on('collapse-blink', function(e, element) {
        collapseBlink(element);
    });

    eventManager.once('e24-front-embed-loaded', function () {
        var appnexusMeta = $('[name="appnexus-page-config"]');
        if (appnexusMeta.length) {
            placementPrefix = 'front-';
            var config = appnexusMeta.data('page-config');
            var placements = appnexusMeta.data('placements');

            Ads.onReady(function() {
                apntag.clearRequest();
                apntag.setPageOpts(config);
            });

            if ($('html').hasClass('desktop')) {
                // Set wallpaper sticky container height - with additional offset to prevent wp styling issue in frontembed
                var el = document.getElementById('wallpaper-background-container');
                el.style.height = 'calc(' + $('.ad.fullscreen').offset().top + 'px - 100vh - 330px)';
            }

            // Handle placement groups (disabled on mobile)
            if (lib.isMobile()) {
                Ads.renderAd(_.map(placements, function(p) { return p; }));
            } else {
                _.each(placements, function(placementGroup, groupName) {
                    // Horseshoe placements are not defined on front embed, so we can skip them
                    if (groupName === 'horseshoe') {
                        return;
                    }

                    Ads.renderAd(_.map(placementGroup, function(p) { return p; }));
                });
            }

            Ads.onReady(Ads.init);
        }
    });

    return Ads;
});
